import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Row, Col } from "react-bootstrap";
import Modal from "react-modal";
import CategoriesForm from "./CategoriesForm";
import Categories from "./Categories";
import SearchNButtons from "../../common-components/SearchNButtons";
import { fetchBlogCategoriesData } from "../../../redux/ad-blog-reducers/blogSlice";
import CommonStructured from "../../common-components/CommonStructured";

const SubCategories = ({ userInfoData }) => {
  const dispatch = useDispatch();
  const [isPage, setIsPage] = useState(0);
  const [pageLimit, setPageLimit] = useState(10);
  const iniAllFilter = {
    selectedParentCategory: "",
    isActive: "",
    searchString: "",
  };
  const [allFilters, setAllFilters] = useState(iniAllFilter);
  const iniFilters = {
    page: isPage + 1,
    limit: pageLimit || 10,
    parent_category: allFilters.selectedParentCategory?.value || "",
    status: allFilters.isActive?.value || "",
  };
  const [filters, setFilters] = useState(iniFilters);
  const [searchFilterApplied, setSearchFilterApplied] = useState(false);

  const iniModvalues = {
    isModOpen: false,
    cardName: "",
    rowData: "",
  };
  const [modValues, setModValues] = useState(iniModvalues);

  const onCloseModal = () => {
    setModValues(iniModvalues);
  };

  const onClickSearch = () => {
    setIsPage(0);

    if (allFilters.searchString) {
      setSearchFilterApplied(true);
      setFilters((prevs) => ({ ...prevs, search: allFilters.searchString }));
    }
  };

  function getBlogCategories(filters) {
    dispatch(
      fetchBlogCategoriesData({
        filters: filters,
        token: userInfoData?.token,
      })
    );
  }

  useEffect(() => {
    getBlogCategories(filters);
  }, [filters]);

  useEffect(() => {
    setFilters((prevs) => ({
      ...prevs,
      page: isPage + 1,
      limit: pageLimit || 10,
      parent_category: allFilters.selectedParentCategory?.value || "",
      status: allFilters.isActive?.value || "",
    }));
  }, [
    isPage,
    pageLimit,
    allFilters.selectedParentCategory,
    allFilters.isActive,
  ]);

  useEffect(() => {
    if (allFilters.searchString?.length === 0) {
      setSearchFilterApplied(false);
      setFilters((prevs) => ({ ...prevs, search: "" }));
      setIsPage(0);
    }
  }, [allFilters.searchString]);

  return (
    <>
      <Modal
        isOpen={modValues.isModOpen}
        onRequestClose={onCloseModal}
        contentLabel="Modal"
        ariaHideApp={false}
      >
        {modValues.cardName === "add" || modValues.cardName === "edit" ? (
          <CategoriesForm
            userInfoData={userInfoData}
            rowData={modValues.rowData}
            isEdit={modValues.cardName === "edit"}
            closeModal={onCloseModal}
            callFunction={() => getBlogCategories(filters)}
          />
        ) : null}
      </Modal>

      <Row>
        <Col>
          <CommonStructured
            pageHeading={"Blog Sub Categories"}
            createBtnTxt={"+ Add New Blog Sub Category"}
            onClickCreateBtn={() =>
              setModValues((prevs) => ({
                ...prevs,
                isModOpen: true,
                cardName: "add",
              }))
            }
            isReload={() => getBlogCategories(filters)}
          />
        </Col>
      </Row>

      <Row>
        <Col>
          <SearchNButtons
            pageName={"blog_categories"}
            pageName1={"blog_sub_categories"}
            filters={allFilters}
            setFilters={setAllFilters}
            searchFilterApplied={searchFilterApplied}
            onClickSearch={onClickSearch}
          />
        </Col>
      </Row>

      <Row>
        <Col>
          <Categories
            isPage={isPage}
            setIsPage={setIsPage}
            pageLimit={pageLimit}
            setPageLimit={setPageLimit}
            setModValues={setModValues}
            callFunction={() => getBlogCategories(filters)}
            userInfoData={userInfoData}
          />
        </Col>
      </Row>
    </>
  );
};

export default SubCategories;
